import { API_MAP, agent } from 'helpers';
class CurrencyService {
  static listMyConnects(pagination?: any) {
    return agent.get(`${API_MAP.listMyConnects}?per_page=${pagination.per_page}&page=${pagination.current_page}`);
  }
  static listConnects() {
    return agent.get(`${API_MAP.listConnects}`);
  }

  static listActionsConnect(connectId: any) {
    return agent.get(`${API_MAP.listActionsMyConnect.replace('{connect_id}', connectId)}`);
  }

  static saveNewConnect(connect: any) {
    return agent.post(`${API_MAP.insertNewConnect}`, connect);
  }

  static updateConnect(connect: any) {
    return agent.put(`${API_MAP.updateConnect}`, connect);
  }

  static saveNewAction(connectId: any, action: any) {
    action.active = action.active ? 1 : 0;

    return agent.post(`${API_MAP.insertNewAction.replace('{connect_id}', connectId)}`, action);
  }

  static listTriggers() {
    return agent.get(`${API_MAP.listTriggers}`);
  }

  static listOptions(autoResponderId: any) {
    return agent.get(`${API_MAP.listConnectOptions.replace('{autoresponder_id}', autoResponderId)}`);
  }

  static listConnectProducts() {
    return agent.get(`${API_MAP.listConnectProducts}`);
  }

  static loadConnect(connectId: any) {
    return agent.get(`${API_MAP.loadConnect.replace('{connect_id}', connectId)}`);
  }

  static loadAction(connectId: any, actionId: any) {
    return agent.get(`${API_MAP.loadAction.replace('{connect_id}', connectId).replace('{action_id}', actionId)}`);
  }

  static changeStatusConnect(connectId: any, active: boolean) {
    return agent.put(`${API_MAP.changeStatusConnect.replace('{connect_id}', connectId)}`, { active });
  }

  static updateAction(connectId: any, action: any) {
    action.active = action.active ? 1 : 0;

    return agent.put(`${API_MAP.updateAction.replace('{connect_id}', connectId).replace('{action_id}', action.id)}`, action);
  }

  static actionFields(autoResponder: any, provider: any, field: any, params?: any) {
    let par = '';
    if (params) {
      par = `&${params}`;
    }
    return agent.get(
      `${API_MAP.connectActionFields.replace('{provider_id}', provider).replace('{autoresponder_id}', autoResponder)}?field=${field}${par}`
    );
  }

  static validateMailChimp(code: string, description: string) {
    return agent.post(`${API_MAP.validateMailChimp}`, { code, description });
  }

  static validateAweber(oauth_token: string, oauth_verifier: string, description: string) {
    return agent.post(`${API_MAP.validateAweber}`, { oauth_token, oauth_verifier, description });
  }

  static validateInfusion(code: string) {
    return agent.post(`${API_MAP.validateInfusionsoft}`, { code });
  }

  static validateRDStation(code: string, description: string) {
    return agent.post(`${API_MAP.validateRDStation}`, { code, description });
  }
}
export default CurrencyService;
